export const TRANSITION_SOURCE_BLOCK_COOKIE_TTL_MS = 30 * 1000;
